/*
 * @Author: 四川华西绿舍建材有限公司
 * @Date: 2024-03-08 09:26:34
 * @LastEditors: hexy
 * @LastEditTime: 2024-03-21 15:54:55
 * @Description: 
 * @FilePath: \ICPSxin\src\api\basicConfig\mixIssue.js
 */
import request from '@/utils/request'
// 获取历史记录
export function queryHistoryByPlan(data) {
  return request({
    url: '/icps/plan-mix-proportion/quertyListByPlan',
    method: 'get',
    params:data,
  })
}
// 获取原料库
export function getRaw(data) {
  return request({
    url: '/icps/plan-mix-proportion/getWareHouseByMix',
    method: 'post',
    data
  })
}


// 获取计划配合比(返回多个产线数据)
export function queryOneByPlan(data) {
  return request({
    url: '/icps/plan-mix-proportion/quertyOneByPlan',
    method: 'get',
    params:data,
  })
}
// 获取质量管理配置比
export function qualityMixProportionPage(data) {
  return request({
    url: '/icps/system/sign/basics/plan/qualityMixProportionPage',
    method: 'post',
    data
  })
}

// 配合比保存
export function saveMixRatio(data) {
  return request({
    url: '/icps/plan-mix-proportion/save',
    method: 'post',
    data
  })
}
// 自动取样时间设置
export function judgeMixCheckTimeControl(params) {
  return request({
    url: '/icps/system/sign/basics/technological/judgeMixCheckTimeControl',
    method: 'get',
    params
  })
}